<template>
<div style="margin: 0 30px">
  <div class="box-card">
    <el-row style="font-size: 18px">
      <el-col :span="3" v-if="moduletag === 2">
        <div v-if="oldPerson.elderly_photo !== ''" class="bg-photo">
          <img :src="oldPerson.elderly_photo">
        </div>
        <div v-else class="bg-photo">
          <img v-if="oldPerson.gender === '2'" src="static/nv.png">
          <img v-else src="static/nan.png">
        </div>
      </el-col>
      <el-col :span="3" v-else>
        <div v-if="oldPerson.photourl !== ''" class="bg-photo">
          <img :src="oldPerson.photourl">
        </div>
        <div v-else class="bg-photo">
          <img v-if="oldPerson.sex === 0" src="static/nv.png">
          <img v-if="oldPerson.sex === 1" src="static/nan.png">
        </div>
      </el-col>
      <el-col :span="21">
        <el-col :span="12">
          <span style="font-weight: bold">姓名：</span>
          <span v-if="moduletag === 2"> {{oldPerson.elderly_name}}</span>
          <span v-else> {{oldPerson.name}}</span>
        </el-col>
        <el-col :span="12">
          <span style="font-weight: bold">性别：</span>
          <span v-if="moduletag === 2"> {{getgender(oldPerson.gender)}}</span>
          <span v-else><span v-if="oldPerson.sex === 0">女</span><span v-if="oldPerson.sex === 1">男</span></span>
        </el-col>
        <el-col :span="12">
          <span style="font-weight: bold">生日：</span>
          <span v-if="moduletag === 2">{{getAgeDesc(oldPerson.birth_date)}}</span>
          <span v-else>{{getAgeDesc(oldPerson.birthday)}}</span>
          (<span v-if="moduletag === 2">{{oldPerson.birth_date}}</span><span v-else>{{oldPerson.birthday}}</span>)
        </el-col>
        <el-col :span="12">
          <span style="font-weight: bold">身份证号：</span>
          <span v-if="moduletag === 2"> {{oldPerson.id_number}}</span>
          <span v-else> {{oldPerson.idcard_num}}</span>
        </el-col>
      </el-col>
    </el-row>
  </div>
  <div v-if="elderlyassessment !== ''">
  <el-row style="height: 40px;margin-top: 20px;font-size: 18px">
    <el-col :span="8">
      <span>自理能力得分：<span v-if="elderlyassessment.daily_activity_score">{{elderlyassessment.daily_activity_score}}</span></span>
    </el-col>
    <el-col :span="8">
      <span>基础运动能力得分： <span v-if="elderlyassessment.extra_info && elderlyassessment.extra_info.sports_score">{{elderlyassessment.extra_info.sports_score}}</span></span>
    </el-col>
    <el-col :span="8">
      <span>精神状态得分：<span v-if="elderlyassessment.mental_state_score">{{elderlyassessment.mental_state_score}}</span></span>
    </el-col>
  </el-row>
  <el-row style="height: 40px;font-size: 18px">
    <el-col :span="8">
      <span>感知觉与社会参与得分： <span v-if="elderlyassessment.extra_info && elderlyassessment.extra_info.society_perception_score">{{elderlyassessment.extra_info.society_perception_score}}</span></span>
    </el-col>
    <el-col :span="8">
      <span>评估人员：<span v-if="elderlyassessment.assessor_name">{{elderlyassessment.assessor_name}}</span></span>
    </el-col>
    <el-col :span="8">
      <span>评估人员日期：<span v-if="elderlyassessment.assessment_completion_date">{{elderlyassessment.assessment_completion_date}}</span></span>
    </el-col>
  </el-row>
  <el-row style="height: 40px;font-size: 18px">
    <el-col :span="8">
      <span>评估地点： <span v-if="elderlyassessment.extra_info && elderlyassessment.extra_info.assessor_address">{{elderlyassessment.extra_info.assessor_address}}</span></span>
    </el-col>
    <el-col :span="8">
      <span>信息提供者：<span v-if="elderlyassessment.informant_name">{{elderlyassessment.informant_name}}</span></span>
    </el-col>
    <el-col :span="8">
      <span>信息提供者日期：<span v-if="elderlyassessment.evaluation_application_date">{{elderlyassessment.evaluation_application_date}}</span></span>
    </el-col>
  </el-row>
  </div>
  <div style="height: 40px;line-height: 40px;text-align: center;font-size: 18px;margin-top: 30px" v-else>
    <span>暂无评估信息。</span><el-button size="mini" type="primary" plain @click="addOpen()">新增</el-button>
  </div>
  <el-button v-if="elderlyassessment !== ''" size="mini" type="primary" plain @click="seeOpen()">查看详情</el-button>
</div>
</template>

<script>
import {queryelderlyassessmentinfo} from '../../../api/yanglaoyuan'

export default {
  name: 'lastTime',
  props: {
    lastObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      moduletag: 1,
      oldPerson: {
        elderly_name: '',
        gender: '',
        id_number: ''
      },
      elderlyassessment: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.oldPerson = this.lastObj.oldPersonRow
    console.log(this.oldPerson)
    this.getInfo()
  },
  methods: {
    getInfo () {
      let data = {
        ep_id: this.oldPerson.id
      }
      queryelderlyassessmentinfo(data).then(res => {
        if (res.data.elderlyassessment.length > 0) {
          let obj = this.clone(res.data.elderlyassessment[0])
          if (obj.extra_info && obj.extra_info !== '') {
            obj.extra_info = JSON.parse(res.data.elderlyassessment[0].extra_info)
          }
          this.elderlyassessment = obj
        }
      }).catch(() => {})
    },
    addOpen () {
      this.$emit('openAdd')
    },
    seeOpen () {
      this.$emit('openEdit', this.elderlyassessment)
    },
    getgender (gender) {
      if (gender === '0') {
        return '未知性别'
      } else if (gender === '1') {
        return '男性'
      } else if (gender === '2') {
        return '女性'
      } else if (gender === '9') {
        return '未说明性别'
      } else {
        return gender
      }
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    }
  }
}
</script>

<style scoped>
.bg-photo img{
  width: 90px;
  height: 116px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/lastTime.vue